var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgWhiteList(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.345 1.291H1.655C.74 1.291 0 2.004 0 2.883v14.322c0 .88.74 1.593 1.655 1.593h10.69c.914 0 1.655-.713 1.655-1.593V2.883c0-.88-.74-1.592-1.655-1.592z",
    fill: "#E6A273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M14 3.765v13.44c.001.209-.04.416-.122.61a1.59 1.59 0 01-.356.52 1.66 1.66 0 01-.536.348 1.71 1.71 0 01-.634.124H2.01L.887 17.212 12.813 2.734 14 3.764z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.814 2.338H2.182c-.788 0-1.426.614-1.426 1.372v12.943c0 .758.638 1.372 1.426 1.372h9.632c.787 0 1.426-.614 1.426-1.372V3.71c0-.758-.639-1.372-1.426-1.372z",
    fill: "#FAFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.204 5.35H2.793a.621.621 0 00-.633.608c0 .337.283.61.633.61h8.411c.35 0 .633-.273.633-.61a.621.621 0 00-.633-.608zM11.204 7.695H2.793a.621.621 0 00-.633.61c0 .335.283.608.633.608h8.411c.35 0 .633-.273.633-.609a.621.621 0 00-.633-.609zM11.204 10.037H2.793a.621.621 0 00-.633.609c0 .336.283.609.633.609h8.411c.35 0 .633-.273.633-.61a.621.621 0 00-.633-.608zM11.204 12.377H2.793a.621.621 0 00-.633.609c0 .336.283.608.633.608h8.411c.35 0 .633-.272.633-.608a.621.621 0 00-.633-.609zM11.204 14.719H2.793a.621.621 0 00-.633.609c0 .336.283.608.633.608h8.411c.35 0 .633-.272.633-.608a.621.621 0 00-.633-.61z",
    fill: "#CEE9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 4.18H5.585a1.97 1.97 0 01-1.366-.544 1.824 1.824 0 01-.566-1.314v-.083c0-.25.104-.49.288-.668a1 1 0 01.693-.276h5.443a1 1 0 01.693.276.926.926 0 01.288.668v.086a1.824 1.824 0 01-.566 1.31 1.97 1.97 0 01-1.362.545z",
    fill: "#000",
    opacity: 0.15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.786 3.679H5.241c-.51 0-1-.195-1.362-.541a1.825 1.825 0 01-.57-1.307v-.09c0-.25.104-.49.288-.668A1 1 0 014.29.797h5.443a1.015 1.015 0 01.696.275.942.942 0 01.289.669v.09a1.825 1.825 0 01-.57 1.307 1.97 1.97 0 01-1.362.54z",
    fill: "#FFD580"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .797)",
    d: "M0 0h14v18H0z"
  })))));
}
export default SvgWhiteList;